import React, { useState, useEffect } from "react";
import _ from "lodash";
import RetailDesignationForm from "./RetailDesignationsForm";
import LdnDesignationForm from "../../shared/designations/LdnDesignationForm";
import Logo from "~/images/Abbvie.png";

const AbbvieDesignations = (props) => {
  const manufacturerName = "abbvie";
  const vanityManufacturerName = "AbbVie";

  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] =
    useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({
    abbvie: {},
    pharmacyclics: {},
  });

  useEffect(() => {
    props.setCompletedDesignations(isComplete());
  }, [manufacturerFormDetails]);

  const isComplete = () => {
    const openForms = _.flatMap(manufacturerFormDetails, (manufacturer) =>
      _.filter(manufacturer, (form) => form.open)
    );
    return openForms.length ? _.every(openForms, ["completed", true]) : true;
  };

  const renderRetail = () => (
    <RetailDesignationForm
      entities={props.entities}
      kind="retail"
      manufacturerFormDetails={manufacturerFormDetails}
      setManufacturerFormDetails={setManufacturerFormDetails}
      manufacturer={manufacturerName}
      manufacturerName={vanityManufacturerName}
      setRetailSelectedSpecialtyPharmacy={setRetailSelectedSpecialtyPharmacy}
      setRetailHasSelectedSpecialtyPharmacy={setRetailHasSelectedSpecialtyPharmacy}
    />
  );

  const sharedLdnProps = {
    manufacturerFormDetails: manufacturerFormDetails,
    manufacturer: manufacturerName,
    manufacturerVanityName: vanityManufacturerName,
    setManufacturerFormDetails: setManufacturerFormDetails,
    entities: props.entities,
  };

  return (
    <div>
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={Logo} alt="AbbVie Logo" />
        </div>
        <div className="designation_form__section__header__title">{vanityManufacturerName}</div>
      </div>
      {renderRetail()}
      <LdnDesignationForm
        {...sharedLdnProps}
        network="duopa"
        isBlocked={_.some(props.entities, (e) => e.blocked.includes("duopa"))}
      />
      <LdnDesignationForm
        {...sharedLdnProps}
        manufacturer="pharmacyclics"
        network="imbruvica"
        isBlocked={_.some(props.entities, (e) => e.blocked.includes("imbruvica"))}
      />
      <LdnDesignationForm
        {...sharedLdnProps}
        network="venclexta"
        isBlocked={_.some(props.entities, (e) => e.blocked.includes("venclexta"))}
      />
      <LdnDesignationForm
        {...sharedLdnProps}
        network="vyalev"
        isBlocked={_.some(props.entities, (e) => e.blocked.includes("vyalev"))}
      />
      <LdnDesignationForm
        {...sharedLdnProps}
        network="elahere"
        isBlocked={_.some(props.entities, (e) => e.blocked.includes("elahere"))}
      />
      <LdnDesignationForm
        {...sharedLdnProps}
        network="emrelis"
        isBlocked={_.some(props.entities, (e) => e.blocked.includes("emrelis"))}
      />
      <LdnDesignationForm
        {...sharedLdnProps}
        network="decnupaz"
        isBlocked={_.some(props.entities, (e) => e.blocked.includes("decnupaz"))}
      />
      <LdnDesignationForm
        {...sharedLdnProps}
        network="juvmo"
        isBlocked={_.some(props.entities, (e) => e.blocked.includes("juvmo"))}
      />
    </div>
  );
};

export default AbbvieDesignations;
